package app.bloomey.web.modules.library

import com.copperleaf.ballast.BallastViewModelConfiguration
import com.copperleaf.ballast.build
import com.copperleaf.ballast.core.BasicViewModel
import com.copperleaf.ballast.eventHandler
import com.copperleaf.ballast.withViewModel
import kotlinx.coroutines.CoroutineScope

class LibraryViewModel(
    coroutineScope: CoroutineScope,
    configBuilder: BallastViewModelConfiguration.Builder = BallastViewModelConfiguration.Builder(),
) :
    BasicViewModel<LibraryContract.Inputs, LibraryContract.Events, LibraryContract.State>
        (
        coroutineScope = coroutineScope,
        config = configBuilder.withViewModel(
            inputHandler = LibraryInputHandler(),
            initialState = LibraryContract.State(),
            name = "Library",
        ).build(),
        eventHandler = eventHandler {

        })
